import { Helper } from "../../../../dev/utils/Helper";
import { BitmapTextStyleOptions, TextStyleOptions } from "../../../../dev/setting/text/IText";
import { Translator } from "../../../../dev/setting/Translator";
import { SplashView } from "../SplashController";
import { BitmapCountUp } from "../../../component/BitmapCountUp";
import { GameAssets } from "../../../config/texture/GameAssets";
import { TranslationTexts } from "../../../config/translate/TranslationTexts";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { GameData } from "../../../server/data/BaseModel";
import { gsap } from "gsap";

export interface OutroData {
    fsPlayed: number;
    totalAmount: number;
    level: number;
}

export class SplashViewFsOutro extends PIXI.Container implements SplashView {

    private totalWin: PIXI.Text;
    private counter: BitmapCountUp;
    private _timeLine: gsap.core.Timeline;
    private freeSpinPlayedText: PIXI.Text;
    
    private DEFAULT_TXT_STYLE: TextStyleOptions;

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 52,
        letterSpacing: 12
    };
    
    private static _presentationData: OutroData = {
        level: 2,
        totalAmount: 123456789,
        fsPlayed: 1
    };

    private readonly styleTotal: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontSize: 68,
        fontWeight: FontWeight.EXTRA_BOLD,
        fill: [
            "#fffb00",
            "#c93",
        ],
        stroke: "#600",
        strokeThickness: 4
    };

    constructor(textStyle: TextStyleOptions) {
        super();

        this.DEFAULT_TXT_STYLE = textStyle;
        this.init();
        this.visible = false;
    }

    public setData(data: GameData): void {
        this.freeSpinPlayedText.text = Translator.translate(TranslationTexts.FREESPINS_PLAYED) + " " +  data.raw.numberOfFreespinsPlayed.toString();
        this.counter.showValue(data.Win.totalWin);
        // this.counter.visible = !data.Win.isWinBelowStake();
        this.totalWin.visible = !data.Win.isWinBelowStake();
    }

    private init(): void {

        // TEXT TOTAL
        this.totalWin = new PIXI.Text(Translator.translate(TranslationTexts.TOTAL_WIN));
        this.totalWin.style = this.styleTotal;
        this.totalWin.position = new PIXI.Point(0, -240);
        this.totalWin.anchor.set(0.5, 0.5);
        this.addChild(this.totalWin);
        this.totalWin.scale.set(1);

        Helper.ResizeText(this.totalWin,600)

        this.freeSpinPlayedText = new PIXI.Text(Translator.translate(TranslationTexts.FREESPINS_PLAYED));
        this.freeSpinPlayedText.style = this.styleTotal;
        this.freeSpinPlayedText.position = new PIXI.Point(0, 100);
        this.freeSpinPlayedText.anchor.set(0.5, 0.5);
        this.addChild(this.freeSpinPlayedText);

        Helper.ResizeText(this.freeSpinPlayedText,600);

        // COUNTER
        this.counter = this.addChild(new BitmapCountUp(this._style));
        this.counter.alpha = 1;
        this.counter.anchor = new PIXI.Point(0.5, 0.5);
        this.counter.position.set(0, -120)
        this.addChild(this.counter);
        this.counter.showValue(SplashViewFsOutro._presentationData.totalAmount);

        this.onResize();
    }

    

    public play(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onStart: () => {this.visible = true }}));
        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 0.5, alpha: 1 }, 0);
        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onComplete: () => {this.visible = false }}));
        this._timeLine.to(this, { duration: 0.35, alpha: 0 });
        return this._timeLine;
    }

    public onResize(): void {
        if (this._timeLine) this._timeLine.progress(1);
    }
}
